<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form ref="globalPriceSettings" :model="globalPriceSettings" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="4">
            <span>职业培训视频观看时长：</span>
          </el-col>
          <el-col :span="6">
            <el-form-item label=" " prop="trainingVideoWatchingDuration.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格" v-model="globalPriceSettings.trainingVideoWatchingDuration.Value"
                class="input-width" oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <table class="university-video-settings">
          <colgroup>
            <col />
            <col width="220" />
            <col width="200" />
            <col width="200" />
            <col width="200" />
          </colgroup>
          <tr>
            <th>
              <span>大学视频观看时长设置：</span>
            </th>
            <th :colspan="3">
              <span>&nbsp;</span>
            </th>
          </tr>
          <tr v-for="(setting, index) in universityWatchingDurationSettingList" :key="index" :class="{'university-video-settings-group-border': (index + 1) % categoryCount === 0}">
            <td v-if="setting.CourseCategory === supportedCourseCategories[0]" :rowspan="supportedCourseCategories.length">
              <span>{{setting.UniversityGroupName}}</span>
            </td>
            <td>
              <span>{{GLOBAL.enumNormalCourseCategory.getDesc(setting.CourseCategory)}}</span>
            </td>
            <td>
              <el-form-item label="观看时长">
                <el-input :disabled="optionModel.isReadonly" placeholder="请输入观看时长" v-model="setting.WatchingDuration" class="input-width"
                  oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
              </el-form-item>
            </td>
            <td>
              <el-form-item label="免费次数">
                <el-input :disabled="optionModel.isReadonly" placeholder="请输入免费次数" v-model="setting.FreeCount" class="input-width"
                  oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null" />
              </el-form-item>
            </td>
          </tr>
        </table>
        <!-- <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row> -->
      </el-form>
    </div>
    <el-row v-if="!optionModel.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="submitBtnDisable" :loading="isSaving" :type="submitBtnClass" @click="saveChanges">保存更新</el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}

.university-video-settings {
  width: 100%;

  .divider {
    border-left: 1px solid #dcdfe6;
  }

  td {
    vertical-align: top;
  }

  /deep/ .el-form-item{
    margin-bottom: 0;
  }
}

.university-video-settings-title,
.university-video-settings-content {
  .divider {
    text-align: center;
    width: 20px;

    .el-divider {
      height: 40px;
    }
  }
}

.university-video-settings-title {
  margin-bottom: 22px;
}

.university-video-settings-group-border{
  border-bottom: 1px solid #ced3d9;
}
</style>

<script>
import {
  getGlobalPriceSettingByType,
  saveGlobalPriceSetting,
} from "@/service/globalPriceSetting.service";
import {
  getUniversityWatchingDurationSettingList,
  saveUniversityWatchingDurationSettings,
} from "@/service/common.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean,
    },
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的值";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      categoryCount: 4,
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false,
      },
      supportedCourseCategories: [
        this.GLOBAL.enumNormalCourseCategory.NormalClass,
        this.GLOBAL.enumNormalCourseCategory.OnlineCourse,
        this.GLOBAL.enumNormalCourseCategory.OMO,
        this.GLOBAL.enumNormalCourseCategory.OfflineCourse,
      ],
      globalPriceSettings: {
        trainingVideoWatchingDuration: {},
      },
      universityWatchingDurationSettingList: [],
      activeUniversityGroup: null,
      submitBtnClass: "info",
      submitBtnDisable: true,
      isSaving: false,
      showError: false,
      errorMessage: "",
      rules: {
        trainingVideoWatchingDuration: {
          Value: [
            {
              required: true,
              message: "时长不能为空",
              trigger: "blur",
            },
            {
              validator: validateValue,
              trigger: "blur",
            },
          ],
        },
      },
    };
  },
  components: {},
  computed: {},
  created() {
    this.categoryCount = this.supportedCourseCategories.length;
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSettings();
    this.loadUniversityWatchingDurationSettingList();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSettings"];
      if (!!$refGPS) {
        $refGPS.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    async loadGlobalPriceSettings() {
      if (!this.isActive) {
        return;
      }

      this.loading = true;

      await getGlobalPriceSettingByType(17).then((result) => {
        if (!!result && result.success) {
          this.globalPriceSettings.trainingVideoWatchingDuration = result.data;
        }
      });

      this.loading = false;
      this.isLoadedData = true;
    },
    async loadUniversityWatchingDurationSettingList() {
      this.loading = true;

      try {
        let result = await getUniversityWatchingDurationSettingList();
        if (!!result && result.success) {
          this.universityWatchingDurationSettingList = result.data;

          let firstSetting =
            this.universityWatchingDurationSettingList.length > 0
              ? this.universityWatchingDurationSettingList[0]
              : null;
          this.activeUniversityGroup = !!firstSetting
            ? firstSetting.UniversityGroupNumber
            : null;
        } else {
          this.universityWatchingDurationSettingList = [];
          this.activeUniversityGroup = null;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    async saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }
      this.isSaving = true;
      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";

      await saveGlobalPriceSetting(
        this.globalPriceSettings.trainingVideoWatchingDuration
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSettings.trainingVideoWatchingDuration.Id =
            result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      await saveUniversityWatchingDurationSettings(
        this.universityWatchingDurationSettingList
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.universityWatchingDurationSettingList = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      this.$message(`保存更新${!showError ? "成功" : "失败"}`);
      this.showError = showError;
      this.errorMessage = errorMessage;

      this.submitBtnDisable = cacheSubmitBtnDisable;
      this.isSaving = false;
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadGlobalPriceSettings();
        this.loadUniversityWatchingDurationSettingList();
      }
    },
    options: function (newVal) {
      this.loadOptionModelFromProps(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/videoWatchingDuration.vue